import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-24 px-4 bg-[#FBF8F4]" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <div className="flex justify-center mb-8" data-id="element-88">
          <div className="w-24 h-1 bg-[#5A7D60]/20 rounded-full" data-id="element-89" />
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-[#EBE5DB] relative overflow-hidden" data-id="element-90">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#5A7D60]" data-id="element-91" />

          <div className="w-16 h-16 bg-[#F5F0E8] rounded-full flex items-center justify-center mb-6 text-[#5A7D60] mx-auto" data-id="element-92">
            <ShieldCheck size={32} data-id="element-93" />
          </div>

          <h2 className="font-serif text-3xl text-[#3D3229] mb-6" data-id="element-94">
            Compra con tranquilidad
          </h2>

          <p className="text-lg text-[#5C4A3A] leading-relaxed mb-2" data-id="element-95">
            Tienes 30 días para explorar todo el contenido. Si sientes que este
            pack no aporta valor a tu familia, te devolvemos el 100% de tu
            inversión.
          </p>

          <p className="text-[#5C4A3A] font-medium" data-id="element-96">
            Sin preguntas incómodas. Sin riesgos.
          </p>
        </motion.div>

        <div className="flex justify-center mt-8" data-id="element-97">
          <div className="w-24 h-1 bg-[#5A7D60]/20 rounded-full" data-id="element-98" />
        </div>
      </div>
    </section>;
}